
    import I18n from 'i18nObj';
    
      import 'translations/outcomes.find_instructions';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('outcomes.find_instructions');
  